import { ReactElement } from 'react';

import { ChakraBox, ChakraTabPanel, ChakraTabPanels } from '@equip.health/ui';

import { SettingsTab } from '~/lib/util/settings.util';

import General from './General';
import Notifications from './Notifications';

const SettingsTabsMap: Record<SettingsTab, ReactElement> = {
  [SettingsTab.GENERAL]: <General />,
  [SettingsTab.NOTIFICATIONS]: <Notifications />,
};

const TOP_LEVEL_ID = 'settings__tabs__panels';

const SettingsPanels = () => (
  <ChakraBox height="100%" overflow="auto">
    <ChakraTabPanels height="100%" id={TOP_LEVEL_ID}>
      {Object.entries(SettingsTabsMap).map(
        ([tab, TabComponent]: [string, ReactElement]) => (
          <ChakraTabPanel id={`${TOP_LEVEL_ID}-${tab}`} key={tab} padding={0}>
            {TabComponent}
          </ChakraTabPanel>
        ),
      )}
    </ChakraTabPanels>
  </ChakraBox>
);

export default SettingsPanels;
